import React, {useState} from "react";
import {Button, ControlLabel, FormControl, FormGroup} from "react-bootstrap";
import {clientImportTimePadEventsFetch, clientImportTimePadSettingsCreate} from "../../../../api/cp";
import {useEventContext} from "../../../context";
import Select from "react-select";

export default ({onSuccess, onClose}) => {
    const {event} = useEventContext();
    const [accessToken, setAccessToken] = useState('');
    const [organizationId, setOrganizationId] = useState(null);
    const [timePadEvent, setTimePadEvent] = useState(null);
    const [timePadEvents, setTimePadEvents] = useState(null);
    const [disabled, setDisabled] = useState(false);

    const handleSubmitAccessToken = async (e) => {
        e.preventDefault();

        setDisabled(true);
        try {
            const timePadEvents = await clientImportTimePadEventsFetch(event.eventKey, accessToken, organizationId);
            setTimePadEvents(timePadEvents);
        } catch (e) {
            console.error(e);
        }
        setDisabled(false);
    }

    const handleSubmitEvent = async (e) => {
        e.preventDefault();

        if (!timePadEvent) {
            return;
        }

        const data = {
            name: timePadEvent.name,
            accessToken,
            settings: {
                organizationId,
                timePadEvent,
            }
        }

        setDisabled(true);
        try {
            const settings = await clientImportTimePadSettingsCreate(event.eventKey, data);
            onSuccess(settings);
        } catch (e) {
            console.error(e);
        }
        setDisabled(false);
    }

    if (null === timePadEvents) {
        return (
            <form onSubmit={handleSubmitAccessToken}>
                <FormGroup>
                    <ControlLabel htmlFor="accessToken">accessToken</ControlLabel>
                    <FormControl
                        type="text"
                        value={accessToken}
                        onChange={(e) => setAccessToken(e.target.value)}
                        disabled={disabled}
                    />
                </FormGroup>
                <FormGroup>
                    <ControlLabel htmlFor="organizationId">ID организации</ControlLabel>
                    <FormControl
                        type="number"
                        value={'' + organizationId}
                        onChange={(e) => setOrganizationId(parseInt(e.target.value))}
                        disabled={disabled}
                    />
                </FormGroup>
                <FormGroup>
                    <Button type="submit" bsStyle="primary" disabled={disabled}>Далее</Button>
                    {' '}
                    <Button onClick={onClose}>Закрыть</Button>
                </FormGroup>
            </form>
        );
    }

    const timePadEventsOptions = timePadEvents.map(({id, name}) => ({value: id, label: name}));

    return (
        <form onSubmit={handleSubmitEvent}>
            <FormGroup>
                <Select
                    options={timePadEventsOptions}
                    value={timePadEventsOptions.find(({value}) => value === timePadEvent?.id)}
                    onChange={({value}) => setTimePadEvent(timePadEvents.find(({id}) => id === value))}
                    isDisabled={disabled}
                />
            </FormGroup>
            <FormGroup>
                <Button type="submit" bsStyle="primary" disabled={disabled}>Создать</Button>
                {' '}
                <Button onClick={onClose}>Закрыть</Button>
            </FormGroup>
        </form>
    );
}
